import { TOption } from "shared/Select/Select";

export const PAGINATION_OPTIONS: TOption[] = [
  { label: "9", value: 9 },
  { label: "15", value: 15 },
  { label: "18", value: 18 },
];
